import axios from "axios";
import {Storage} from "@/services/Storage";
import {responses} from "@/utils/responses";
import {set} from "vue";
import store from "@/store";

let getNow = function () {
    let date = new Date();
    let d = date.toISOString().split('T')[0]
    let t = date.toISOString().split('T')[1].split('.')[0];
    return d + ` ` + t;
}
const isEmpty = function (obj) {
    if (!obj) {
        return true;
    }
    return Object.keys(obj).length === 0;
}
export default {
    name: 'sales', state: {
        currentSale: 0,
        saleDiscount: {},
        currentSaleLines: [],
        receipts: [],
        latestInvoice: {},
        refundInv: undefined,
        saleDetails: {},
        customer: '',
    },
    getters: {
        getLatestInvoice: (state) => state.latestInvoice,
        getRefundInvoice: (state) => state.refundInv,
        getCustomer: (state) => state.customer,
        getCurrentSale: (state) => state.currentSale,
        getSaleLines: (state) => state.currentSaleLines,
        getSaleTotal: (state) => {
            let saleLines = state.currentSaleLines;
            if (!saleLines || saleLines.length === 0) return 0.00;
            return saleLines.map(line => {
                let total = (line.Qty * line.Unit ) - line.Discount;
                let instructions = line.instructions;
                if (instructions && instructions.length > 0) {
                    let instructionTotal = instructions.map(i => i.Price).reduce((acc, n) => Number(n) + Number(acc))
                    total += Number(instructionTotal);
                }
                return Number(total);
            }).reduce((sum, line) => Number(sum) + Number(line))
        },
        getSaleDiscount: state => {
            if (!isEmpty(state.saleDiscount)) {
                return state.saleDiscount
            } else return {
                type: 'none', value: 0, total: 0
            }
        },
        getSaleUnits: state => state.currentSaleLines.length,
        getSaleVat: (state, getters) => {
            return getters.getSaleTotal * 0.16;
        },
        getSubTotal: (state, getters) => {
            return getters.getSaleTotal - getters.getSaleVat
        },
        getSaleDetails: (state) => state.saleDetails
    },
    mutations: {
        setCurrentSale: (state, data) => state.currentSale = data,
        setSaleDetails: (state, data) => state.saleDetails = data,
        setRefundInvoice: (state, data) => state.refundInv = data,
        setCurrentLines: (state, data) => state.currentSaleLines = data,
        setCustomer: (state, data) => state.customer = data,
        updateSaleLinePrice: async (state, data) => {
            state.currentSaleLines.map(async (line) => {
                let currentPrice = line.Unit;
                if (line.index === data.index) {
                    let stock1 = await Storage.getAllStock();
                    let item = stock1.find(stock => stock.PLU === data.Plu);
                    if (item) {
                        switch (data.priceType) {
                            case "Normal":
                                currentPrice = item.SellingIncl;
                                break;
                            case "At Cost":
                                currentPrice = item.InclCost;
                                break;
                            case "Price 1":
                                currentPrice = item.price1;
                                break;
                            case "Price 2":
                                currentPrice = item.price2;
                                break;
                            case "Price 3":
                                currentPrice = item.price3;
                                break;
                            case "Price 4":
                                currentPrice = item.price4;
                                break;
                            case "Price 5":
                                currentPrice = item.price5;
                                break;
                            default:
                                currentPrice = line.Unit;
                                break;
                        }

                    }
                }
                line.Unit = currentPrice;
                line.Line = (Number(currentPrice * Number(line.Qty)).toFixed(2) ) - line.Discount;
                return line;
            });
        },
        addToCurrentSaleLines: async (state, payload) => {
            let data = payload;
            let item = state.currentSaleLines.find(line => {
                return line.Plu === data.Plu &&
                    line.Unit === data.Unit &&
                    line.Description === data.Description;
            });
            let settings = await Storage.getDeviceSettings();
            if (item && !(settings.SeperateLine)) {
                item.Qty = Number(item.Qty) + Number(payload.Qty);
                item.Line = Number(payload.Unit * item.Qty).toFixed(2);
                const data = [...payload.instructions, ...item.instructions];
                let edited = data.reduce((accumulator, msg) => {
                    if (accumulator.has(msg.CookingNum)) {
                        let m = accumulator.get(msg.CookingNum)
                        m.count += msg.count
                    } else {
                        accumulator.set(msg.CookingNum, msg);
                    }
                    return accumulator;
                }, new Map())
                item.instructions = [...edited.values()]
            } else {
                data.index = state.currentSaleLines.length + 1
                data.savedQty = 0;
                state.currentSaleLines.push(data);
            }
        },
        voidItem: async (state, payload) => {
           
            let item = state.currentSaleLines.find(s => s.index === payload.index)
            let savedQty = item.savedQty;
            let currentQty = item.Qty;
            if (currentQty <= savedQty) {
                let validation = await store.dispatch(`validateSecurityPermission`,`Void`);
                if (!validation) return;
           
                let voidObj = {
                    VoidPlu : item.Plu,
                    VoidDescritpiom : item.Description,
                    VoidQty : 1,
                    VoidValue : item.Unit,
                    SuperVisor : validation.supervisor,
                }
                console.log("We are here ", voidObj);
                store.dispatch(`logItemVoid`, voidObj)
            }
            item.Qty--;
            item.instructions = item.instructions.map((s) => {
                let msg = payload.instructions.find(m => m.CookingNum === s.CookingNum)
                if (msg) {
                    s.count -= msg.count
                }
                return s;
            });
            if (item.Qty <= 0) {
                let arr = state.currentSaleLines
                state.currentSaleLines = $utils.removeIf(arr, s => s.index !== payload.index)
            }
        },
        voidLine:async (state, data) => {

            let item = state.currentSaleLines.find(s => s.index === data.index)
            let savedQty = item.savedQty;
            let currentQty = item.Qty;
            if (currentQty <= savedQty) {
                let validation = await store.dispatch(`validateSecurityPermission`,`Void`);
                if (!validation) return;
                let voidObj = {
                    VoidPlu : item.Plu,
                    VoidDescritpiom : item.Description,
                    VoidQty : item.Qty,
                    VoidValue : item.Line,
                    SuperVisor : validation.supervisor,
                }
           
                store.dispatch(`logItemVoid`,voidObj)
            }
            let arr = state.currentSaleLines
            state.currentSaleLines = $utils.removeIf(arr, s => {
                return s.index !== data.index;
            })
        },
        addReceipt: (state, payload) => {
            state.latestInvoice = payload
            state.receipts.push(payload)
            state.currentSaleLines = []
            state.saleDiscount = 0.00
        },
        applyDiscount: (state, payload) => state.saleDiscount = payload,
        clearSale: (state) => {
            state.currentSaleLines = [];
            state.currentSale = 0;
            state.customer = '';
            state.debtorCurrency = null;
            state.saleDiscount = undefined;
        },
        clearDiscount: (state) => state.saleDiscount = undefined,

    },
    actions: {
        parseInvoice: async (context, payload) => {
            let user = await Storage.getCurrentUser();
            let invoice = {
                PC: localStorage.getItem('_capuid'),
                saleNumber: context.state.currentSale,
                date: null,
                user: user.Username,
                customer: context.getters.getCustomer,
                paymentType: payload.type,
                items: context.state.currentSaleLines,
                invoice: (!payload.refund) ? context.state.currentSale : payload.oldInv,
                discount: (!payload.refund) ? parseFloat(context.getters.getSaleDiscount.total) : 0,
                vat: (!payload.refund) ? parseFloat(context.getters.getSaleVat) : 0,
                subTotal: (!payload.refund) ? parseFloat(context.getters.getSubTotal) : parseFloat(payload.total),
                total: parseFloat(payload.total),
                paidAmount: (!payload.refund) ? parseFloat(payload.paid) : parseFloat(payload.total),
                change: (!payload.refund) ? parseFloat(payload.change) : 0,
                units: (!payload.refund) ? context.getters.getSaleUnits : payload.items.length,
                refund: payload.refund,
            };

            if (payload.type === 'Split') {
                invoice.split = [
                    {
                        method: 'cash',
                        amount: payload.splitArray.cash
                    }, {
                        method: 'card',
                        amount: payload.splitArray.card
                    }, {
                        method: '543',
                        amount: payload.splitArray.mobileMoney
                    },

                    {
                        method: 'Kazang',
                        amount: payload.splitArray.Kazang
                    },

                    {
                        method: 'Spenn',
                        amount: payload.splitArray.Spenn
                    },
                ];
                for (let i = 0; i < payload.splitArray.other.length; i++) {
                    let method = payload.splitArray.other[i];
                    invoice.split.push({
                        method: method.Name,
                        amount: method.amount
                    });
                }
            }

            if ((payload.type === 'Kazang' || (payload.type === 'Split' && payload.splitArray.Kazang > 0)) ||
                (payload.type === 'Spenn' || (payload.type === 'Split' && payload.splitArray.Spenn > 0))) {
                invoice.SecondRefrence = payload.SecondRefrence
            }

            if (payload.type === 'Kazang') {
                invoice.total += invoice.discount;
            }
            return invoice
        },
        processTransaction: async (context, payload) => {
            let invoice = await context.dispatch('parseInvoice', payload)
            return context.dispatch('processInvoice', invoice)
        },


        processInvoice: async (context, payload) => {
            let store = await Storage.getDefaultStore();
            return axios.post(serverApi + `invoice/${store.StoreDB}/mobile`, payload)
                .then(async ({data}) => {
                    if (typeof data === 'string') {
                        let correctedData = data.replaceAll(/NaN/g, '0');
                        data = JSON.parse(correctedData);
                    }
                    if (data.status === 200) {
                        context.commit('setCurrentSale', 0)
                        context.commit('addReceipt', data.response);
                        context.commit('clearDiscount');
                        context.commit('setSaleDetails', {});
                        context.dispatch('BtPrint', {
                            invoice: data.response.invoice, reprint: false
                        }).catch(({message}) => responses.throwErr(message))
                        context.commit('setCurrentSale', 0)
                        context.commit('setCustomer', "")
                        return true;
                    }
                }).catch((err) => errorHandler.tomcatError(err))
        },
        BtPrint: async (context, payload) => {
            let store = await Storage.getDefaultStore();
            await axios.get(franchiseTomcatApi + `invnumandi/${payload.invoice}/db/${store.StoreDB}`)
            return axios.post(serverApi + `invoice/${store.StoreDB}/print`, {
                invoice: payload.invoice, pc: context.getters.getDeviceSettings.PC, reprint: payload.reprint,
            }).then(({data}) => window.location.href = `rawbt:base64,${data}`)
                .catch((err) => errorHandler.tomcatError(err))
        },
        openCashDrawer: () => {
            return axios.get(serverApi + `print/kick`)
                .then(({data}) => window.location.href = `rawbt:base64,${data}`)
                .catch((err) => errorHandler.tomcatError(err))
        },
        async getAllInvoices(context, payload) {
            let store = await Storage.getDefaultStore();
            let user = await Storage.getCurrentUser();
            if (!payload.viewAll) {
                payload.user = user.Username;
            } else {
                delete payload.user;
            }
            return axios.post(franchiseTomcatApi + `savetable/${store.StoreDB}/search`, payload)
                .then(({data}) => data)
                .catch((err) => errorHandler.tomcatError(err))
        },

        async getAllPaymentMethodsUsed() {
            let store = await Storage.getDefaultStore();
            return axios.get(franchiseApi + `sales/getAllPaymentTypes/${store.StoreDB}`)
                .then(({data}) => data)
                .catch((err) => errorHandler.tomcatError(err))
        },

        async getInvoiceLines(context, inv) {
            let store = await Storage.getDefaultStore();
            return axios.get(franchiseTomcatApi + `completedsale/${store.StoreDB}/getInvNum`, {params: {invoice: inv}})
                .then(({data}) => {
                    context.commit('setRefundInvoice', data)
                    return data;
                }).catch((err) => errorHandler.tomcatError(err))
        },
        reprintLastInvoice: async (context) => {
            let invoice = context.getters.getLatestInvoice.invoice;
            if (invoice) {
                return context.dispatch('BtPrint', {invoice: invoice, reprint: true});
            }
            let store = await Storage.getDefaultStore();
            return axios.get(franchiseTomcatApi + `completedsale/${store.StoreDB}/getLastInvoiceNumber`)
                .then(({data}) => context.dispatch('BtPrint', {invoice: data, reprint: true}))
                .catch((err) => errorHandler.tomcatError(err))
        },
        openTable: async (context, tab) => {
            let items = tab.items.map((item, index) => {
                item.index = index;
                item.savedQty = item.Qty;
                return item
            })
            let saleNumber = tab.saleNumber;
            await context.commit('setCurrentSale', saleNumber)
            await context.commit('setCurrentLines', items)
            await context.commit('setCustomer', tab.customer)
            return true;
        },
        logItemVoid : async (context, payload) => {
            let store = await Storage.getDefaultStore();
            let settings = await Storage.getDeviceSettings();
            let user = await Storage.getCurrentUser();
            payload.User = user.Username;
            payload.PC = settings.PC;
            payload.Reason = `Sale No. ${context.getters.getCurrentSale}`;
            console.log("Our payload ",payload)

            if(payload.VoidDescritpiom && payload.VoidPlu && payload.VoidQty && payload.VoidValue){
                payload.Plu =  payload.VoidPlu;
                payload.Description = payload.VoidDescritpiom;
                payload.Qty= payload.VoidQty;
                payload.Line=  payload.VoidValue;
            }
            
            let data ={     
                VoidPlu: payload.Plu,
                VoidDescritpiom: payload.Description,
                VoidQty: payload.Qty,
                VoidValue: payload.Line,
                SuperVisor: payload.User,
                User: payload.User,
                PC: payload.PC,
                Reason: payload.Reason,
            }
            console.log(data)

            return axios.post(serverApi+`supervisorOverrides/${store.StoreDB}/logItemVoid`,data)
                .catch(err=>errorHandler.tomcatError(err,false,`Could Not Void`));
        },

    }
}
